import { Box, BoxProps } from "@chakra-ui/react";
import { compact } from "lodash";
import AddWbr from "components/Shared/AddWbr";
import { makeFormatDate } from "utils/formatting";

function getDateTimeParts(formatted: string): string[] {
  const parts = formatted.match(/([a-z]+,\s)?(.*?)((?:\s[a-z]+|,)\s)(\d+:.*)/i);

  if (!parts || parts.length < 5) return [formatted];

  const [weekdayPart, datePart, separator, timePart] = parts.slice(1);

  if (separator.trim() === ",") {
    return compact([weekdayPart, `${datePart}${separator}`, timePart]);
  }

  return compact([weekdayPart, datePart, `${separator}${timePart}`]);
}

export type DatetimeProps = BoxProps & {
  datetime: ISODateTime | null | undefined;
  format?: string;
};

export default function DateTime({
  datetime,
  format = "PPPpp",
  ...rest
}: DatetimeProps) {
  if (!datetime) return null;

  const formatted = makeFormatDate(format)(datetime);

  if (!formatted) return null;

  const parts = getDateTimeParts(formatted);

  return (
    <Box as="time" dateTime={datetime} isTruncated {...rest}>
      <AddWbr parts={parts} />
    </Box>
  );
}
